import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

// Import language resources
import en from './locales/en.json'
import vi from './locales/vi.json'

// Available languages
export const languages = {
  en: {
    name: 'English',
    flag: '🇺🇸',
    dir: 'ltr'
  },
  vi: {
    name: 'Tiếng Việt',
    flag: '🇻🇳',
    dir: 'ltr'
  }
}

// Language resources
const resources = {
  en: {
    translation: en
  },
  vi: {
    translation: vi
  }
}

i18n
  // Load translations from backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: false, // process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false // React already escapes values
    },

    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'sessionStorage', 'navigator', 'htmlTag'],

      // Keys or params to lookup language from
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',

      // Cache user language on
      caches: ['localStorage', 'sessionStorage']
    },

    backend: {
      // Load translations from public/locales folder
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },

    // Supported languages
    supportedLngs: Object.keys(languages),

    // Default namespace
    defaultNS: 'translation',

    // Namespaces
    ns: ['translation', 'common', 'auth', 'dashboard', 'errors'],

    // React i18next options
    react: {
      useSuspense: false
    }
  })

export default i18n
